import { PopperPlacementType } from '@mui/material'
import { TOUR_ANCHORS, tourSelector } from '../tour/anchors'

export type ProductUpdateKind = 'new' | 'fix' | 'improved'

export type ProductUpdateMedia = { kind: 'image' | 'video'; src: string; alt: string }

export type ProductUpdate = {
  // Stored per clinician once seen, so never rename or reuse one.
  id: string
  kind: ProductUpdateKind
  title: string
  body: string
  media?: ProductUpdateMedia
  // Spotlit when on screen, else centred; `opensCareTeamChat` needs a patient open.
  target?: { selector: string; placement?: PopperPlacementType; opensCareTeamChat?: boolean }
}

// Newest first; media shows sample data, never PHI.
export const PRODUCT_UPDATES: ProductUpdate[] = [
  {
    id: 'product-updates-walkthrough',
    kind: 'new',
    title: 'Product update announcements built into the dashboard',
    body: "It's me! I'm the product update announcement. From now on, important updates that were made to the dashboard since you have last used it will be announced here! If it becomes annoying we can tweak it of course.",
    target: { selector: tourSelector(TOUR_ANCHORS.productUpdatesButton), placement: 'bottom-end' },
  },
  {
    id: 'care-coordination-ticket-from-care-team-chat',
    kind: 'new',
    title: 'Request care cord support from the care team chat',
    body: 'You can now request support from care cord using the new “Submit a ticket here!” option on the bottom of the care team chats. The Zendesk ticket form it opens is prefilled with your role as a Provider and the dashboard link for the PT.',
    target: {
      selector: tourSelector(TOUR_ANCHORS.careCoordinationTicket),
      placement: 'left',
      opensCareTeamChat: true,
    },
  },
  {
    id: 'caseload-lab-results-alert',
    kind: 'new',
    title: 'See new lab results on the caseload',
    body: 'In the All and Psychiatrist views, a flask icon will appear when the PT has a new lab result. It clears once a psychiatrist opens the completed lab order in the Feed or the results note in Participant history.',
    target: { selector: tourSelector(TOUR_ANCHORS.caseload), placement: 'right-start' },
  },
  {
    id: 'caseload-care-team-chat-and-lab-filters',
    kind: 'new',
    title: 'New caseload filters',
    body: 'You can now filter based on new lab results and/or new care team chat messages.',
    target: { selector: tourSelector(TOUR_ANCHORS.caseloadIndicatorFilters), placement: 'right' },
  },
  {
    id: 'psychiatric-intake-note-drops-nutrition',
    kind: 'improved',
    title: 'Updated psychiatric intake note',
    body: 'The psychiatric intake note no longer asks for a nutrition track or physical appearance.',
  },
]
